export default __webpack_public_path__ + "static/media/kangoo-gallery-4.060c12af.jpg";